import React, { FC } from "react";
import ReusableAccordian from "../ReusableAccordion";
import SizeLayout from "../SizeLayout";
import PleaseNote from "../PleaseNote";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import useWidthSelector from "./useWidthSelector";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

const UnitSizeAccordian: FC = () => {
  const {
    handleFractionChange,
    handleWidthChange,
    widthErr,
    unitSizeFraction,
    width,
  } = useWidthSelector();

  return (
    <ReusableAccordian
      accordionName="unitSize"
      heading="Net Frame Width"
      secondaryHeading=" Select a Width"
      required5={true}
    >
      <ColLayout>
        <PleaseNote notes="We recommend Net Frame Width to be 1 inch less than the Rough Opening Width" />

        <RowLayout>
          <SizeLayout
            size={width}
            handleChange={handleWidthChange}
            sizeErr={widthErr}
            name="width"
            fractionValue={unitSizeFraction}
            handleFractionChange={handleFractionChange}
          />
        </RowLayout>
      </ColLayout>
    </ReusableAccordian>
  );
};

export default UnitSizeAccordian;
